import { GameListener } from 'game-logic';
import { GameRound } from './game-round';
import { RoundParams } from './round-params';

export abstract class RoundCreator {
  public startNewRemoteRound(gameListener: GameListener, logicVersion = 1): void {
    this.startNewRound(this.createRemoteRoundParams(gameListener, logicVersion));
  }

  public startNewLocalRound(gameListener: GameListener): void {
    this.startNewRound(this.createLocalRoundParams(gameListener));
  }

  public abstract startNewRound(roundParams: RoundParams): GameRound;

  public abstract createRemoteRoundParams(
    gameListener: GameListener,
    logicVersion: number,
  ): RoundParams;

  public abstract createLocalRoundParams(gameListener: GameListener): RoundParams;
}
